import { motion } from "framer-motion";
import { Gift, Compass, Users } from "lucide-react";
import { useTheme, FRIENDS_MODE_ENABLED } from "@/contexts/ThemeContext";

const modeIcons = { birthday: Gift, discover: Compass, friends: Users };

export default function ModeSwitcher() {
  const { mode, setMode, theme, themes } = useTheme();

  return (
    <div
      className="sticky top-0 z-[60] px-4 pt-3 pb-2"
      style={{ background: theme.headerGradient }}
      data-testid="mode-switcher"
    >
      <div className="flex items-center gap-2">
        {/* Birthday pill */}
        <ModePill
          modeKey="birthday"
          label="Birthday"
          icon={Gift}
          active={mode === "birthday"}
          theme={themes.birthday}
          onClick={() => setMode("birthday")}
        />

        {/* Discover pill */}
        <ModePill
          modeKey="discover"
          label="Discover"
          icon={Compass}
          active={mode === "discover"}
          theme={themes.discover}
          onClick={() => setMode("discover")}
        />

        {/* Friends pill */}
        {FRIENDS_MODE_ENABLED ? (
          <ModePill
            modeKey="friends"
            label="Friends"
            icon={Users}
            active={mode === "friends"}
            theme={themes.friends}
            onClick={() => setMode("friends")}
          />
        ) : (
          <div
            className="flex items-center gap-1.5 px-3.5 py-2 rounded-full cursor-default select-none"
            style={{
              background: "rgba(34,197,94,0.18)",
              border: "1px solid rgba(34,197,94,0.35)",
            }}
            data-testid="mode-friends-pill"
          >
            <Users className="w-3.5 h-3.5" style={{ color: "#bbf7d0" }} />
            <span className="text-[11px] font-semibold tracking-wide" style={{ color: "#bbf7d0" }}>Friends</span>
            <span
              className="text-[8px] font-bold px-1.5 py-0.5 rounded-full ml-0.5"
              style={{ color: "#86efac", background: "rgba(34,197,94,0.2)" }}
              data-testid="social-coming-soon"
            >
              SOON
            </span>
          </div>
        )}
      </div>
    </div>
  );
}

function ModePill({ modeKey, label, icon: Icon, active, theme, onClick }) {
  return (
    <motion.button
      onClick={onClick}
      className="relative flex items-center gap-1.5 px-4 py-2 rounded-full transition-all"
      style={{
        background: active ? theme.primary : `${theme.primary}30`,
        border: `1.5px solid ${active ? theme.primaryLight : `${theme.primary}70`}`,
        color: "#ffffff",
        boxShadow: active ? `0 2px 10px ${theme.primary}80` : "none",
      }}
      whileTap={{ scale: 0.95 }}
      data-testid={`mode-${modeKey}-pill`}
    >
      <Icon className="w-3.5 h-3.5 relative z-10" style={{ color: active ? "#fff" : theme.primaryLight }} />
      <span
        className="text-[11px] font-bold tracking-wide relative z-10 uppercase"
        style={{ color: active ? "#fff" : theme.primaryLight }}
      >
        {label}
      </span>
    </motion.button>
  );
}
